import Input from "./Input";
export default ({ onChange, hasError }) => {
	const handleOnChange = (val) => {
		onChange(val);
	};
	return (
		<Input type="password" onChange={handleOnChange} hasError={hasError} errMsg={"dsadadsads"} />
	);
};
